export default {
  userInfo:{},//用户信息
  token:null
  // userInfo: {
  //   commission: null,
  //   consume_money: null,
  //   consume_oil_money: null,
  //   created_at: "2023-03-13T01:51:23.000000Z",
  //   diesel_money: null,
  //   head_portrait: "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83eqdoSp2I8IkKciciaFFA9EfjOjrYjz9sbH1e2WP6xBWLJfoj4rdoZrX1vqFnsHvlD82prEzMn4T3Ncw/132",
  //   id: 63614,
  //   integral: 0,
  //   is_sign: 0,
  //   nickname: "大雄",
  //   open_id: "oxM_e1QRkdEZbbqcxE6Yd81NhSL4",
  //   petrol_money: null,
  //   phone: "18611348527",
  //   qr_img: "http://xjddi.conjure.net.cn/qrcodes/oxM_e1QRkdEZbbqcxE6Yd81NhSL463303.png",
  //   sub_count: 0
  // },
  // token:'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC94amRkaS5jb25qdXJlLm5ldC5jblwvYXBpXC9vYXV0aF9jYWxsYmFjayIsImlhdCI6MTczMzk1OTk3NCwiZXhwIjoxNzM2NTUxOTc0LCJuYmYiOjE3MzM5NTk5NzQsImp0aSI6IjE1Q2VoUU5RMGpiMXdhQk0iLCJzdWIiOjYzNjE0LCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.TtsWjgA2XWGoUulvh1qxtSEJJj2Re-LeD-XWz2arkG8'
}



// WEBPACK FOOTER //
// ./src/store/user/state.js